import { FaqCategoryInterface } from '../interfaces/faq-category.interface';

export const MOST_FREQUENT_FAQ_CATEGORY_ID = 0;

export const DEFAULT_CATEGORIES: FaqCategoryInterface[] = [
  { id: MOST_FREQUENT_FAQ_CATEGORY_ID, nome: 'Mais Acessadas' }
];
